module.exports = __webpack_public_path__ + "static/step-4.6a2f4add.png";